import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=2442b387&scoped=true&"
import script from "./LoginPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=2442b387&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2442b387",
  null
  
)

export default component.exports